/**
 * A chart.
 *
 * Everything this kind is: how it is made, how it is read back, what it looks
 * like on the page, and how it is edited. Nothing outside this folder needs to
 * know the kind exists. What it shows is shared with a chart placed freely on
 * a page (see `domain/chart.ts`).
 */

import { newChartContent, readChartContent } from '@/domain/chart'
import { readNumber, readString } from '@/domain/json'
import { newId, newSeries, type ChartSection } from '@/domain/section'
import ChartBlock from '@/sections/chart/ChartBlock.vue'
import ChartInspector from '@/sections/chart/ChartInspector.vue'
import type { SectionDefinition } from '@/sections/types'

export const chartSection: SectionDefinition<'chart', ChartSection> = {
  kind: 'chart',
  band: 'content',

  icon: ['M2.5 2.5v11h11', 'M4.5 10.5l3-3 2.5 2 3.5-4.5'],

  create: (id, title) => ({
    id,
    kind: 'chart',
    title,
    ...newChartContent(newSeries()),
    caption: '',
    height: 70,
  }),

  read: ({ id, title, stored }) => ({
    id,
    kind: 'chart',
    title,
    ...readChartContent(stored, newId),
    caption: readString(stored, 'caption'),
    height: readNumber(stored, 'height', 70),
  }),

  block: ChartBlock,
  inspector: ChartInspector,
}
